import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as undoRedoActions from './undoredo.actions';
import * as glossariAction from '../../glossari/store/glossari.actions';
import * as utentiActions from '../../utenti/store/utenti.actions';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class UndoRedoEffects {
    constructor(
        private actions$: Actions
    ) { }

    @Effect()
    undoGlobal$ = this.actions$.pipe(
        ofType(undoRedoActions.UndoRedoActionTypes.UNDO),
        switchMap((action: undoRedoActions.Undo) => {
            switch (action.payload.type) {
                case glossariAction.UPDATE_GLOSSARY_SUCCESS:
                    return [
                        new glossariAction.StartUpdateGlossary(action.payload.payload, true),
                        new undoRedoActions.UndoSuccess()
                    ];
                case utentiActions.UPDATE_USER_V2_SUCCESS:
                    return [
                        new utentiActions.StartUpdateUserV2(action.payload.payload, true),
                        new undoRedoActions.UndoSuccess()
                    ];
                case utentiActions.CREATE_USER_SUCCESS:
                    return [
                        new utentiActions.StartRemoveUser(action.payload.payload.idUser, true),
                        new undoRedoActions.UndoSuccess()
                    ];
                case utentiActions.REMOVE_USER_SUCCESS:
                    return [
                        new utentiActions.StartRestoreUser(action.payload.payload.idUser),
                        new undoRedoActions.UndoSuccess()
                    ];
                case glossariAction.ADD_NEW_GLOSSARY_SUCCESS:
                    return [
                        new glossariAction.StartRemoveGlossary(action.payload.payload.idGlos, true),
                        new undoRedoActions.UndoSuccess()
                    ];
                case glossariAction.REMOVE_GLOSSARY_SUCCESS:
                    return [
                        new glossariAction.StartRestoreGlos(action.payload.payload.idGlos),
                        new undoRedoActions.UndoSuccess()
                    ];
            }
        })
    );

    @Effect()
    redoGlobal$ = this.actions$.pipe(
        ofType(undoRedoActions.UndoRedoActionTypes.REDO),
        switchMap((action: undoRedoActions.Redo) => {
            switch (action.payload.type) {
                case glossariAction.UPDATE_GLOSSARY_SUCCESS:
                    return [
                        new glossariAction.StartUpdateGlossary(action.payload.payload, true),
                        new undoRedoActions.RedoSuccess()
                    ];
                case utentiActions.UPDATE_USER_V2_SUCCESS:
                    return [
                        new utentiActions.StartUpdateUserV2(action.payload.payload, true),
                        new undoRedoActions.RedoSuccess()
                    ];
                case utentiActions.CREATE_USER_SUCCESS:
                    return [
                        new utentiActions.StartRemoveUser(action.payload.payload.idUser, true),
                        new undoRedoActions.RedoSuccess()
                    ];
                case utentiActions.REMOVE_USER_SUCCESS:
                    return [
                        new utentiActions.StartRestoreUser(action.payload.payload.idUser),
                        new undoRedoActions.RedoSuccess()
                    ];
                case glossariAction.ADD_NEW_GLOSSARY_SUCCESS:
                    return [
                        new glossariAction.StartRemoveGlossary(action.payload.payload.idGlos),
                        new undoRedoActions.RedoSuccess()
                    ];
                case glossariAction.REMOVE_GLOSSARY_SUCCESS:
                    return [
                        new glossariAction.StartRestoreGlos(action.payload.payload.idGlos),
                        new undoRedoActions.RedoSuccess()
                    ];
            }
        })
    );

}